'use client';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { EmblaCarousel } from '@/components/EmblaCarousel';
import { ImageComponent } from '@/components/Image';
import type { IPool } from '@/helpers/jackpot';
import { useNavigation } from '@/hooks/navigation';
import { JackpotGemsDefaultPack } from '@/modules/jackpot/components/JackpotGemsPack';
import { useAnimatedPools } from '@/modules/jackpot/hooks';
import { useGetCommonStore } from '@/store';

import { Pool, Pools } from './components/Pools';
import { ScJackpotBanner } from './styled';

const JackpotBanner = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const useCommonStore = useGetCommonStore();
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const { navigate } = useNavigation();
  const { pools } = useAnimatedPools();

  const backgroundImage = isMobileDevice
    ? '/jackpot/banner/bannerMobBg.webp'
    : '/jackpot/banner/bannerBg.webp';

  const handleClick = isMobileDevice
    ? undefined
    : () => navigate('/jackpot', true);

  return (
    <ScJackpotBanner data-testid="jackpot-banner" onClick={handleClick}>
      <ImageComponent
        alt="jackpot banner"
        className="bg"
        fill
        src={backgroundImage}
      />

      <div className="logo" onClick={() => navigate('/jackpot', true)}>
        <ImageComponent
          alt="jackpot logo"
          height={120}
          src="/jackpot/logo.webp"
          width={238}
        />
      </div>

      <div className={`embla-slider-wrapper lang-${language}`}>
        <EmblaCarousel<IPool>
          autoplay={{ delay: 2500, stopOnMouseEnter: true }}
          options={{ loop: true }}
          pagination
          slide={Pool}
          slides={pools}
          slidesPerView={1.1}
          spaceBetween={16}
        />
      </div>

      <Button
        className="btn"
        large
        onClick={() => navigate('/jackpot', true)}
        primary
        wide
      >
        {t('jackpot.banner.cta')}
      </Button>

      {pools.length > 0 && <Pools pools={pools} />}

      <JackpotGemsDefaultPack />
    </ScJackpotBanner>
  );
};

export default JackpotBanner;
